import { ActivityReportsPage as ActivityReports } from './src/page/ActivityReportsPage';

export const ActivityReportsPage = ActivityReports;
